import {hitType} from "../../analytics.helper";
import {userActionTypes} from "../../../../_constants";

// UTILITY-HELPERS ##########################################################

// generic user event that accepts the event and user identifier
const genericUserEvent = (userEvent) => {
	return {
		event: userEvent,
		hitType: hitType.EVENT,
	};
};

// EVENTS ##########################################################

// forgot-password
const forgotPassword = () => genericUserEvent(userActionTypes.PASSWORD_TOKEN_REQUEST);

// sign-up
const signUp = () => genericUserEvent(userActionTypes.CREATE_USER_SUCCESS);

// cancel-account
const cancelAccount = () => genericUserEvent(userActionTypes.CANCEL_ACCOUNT_REQUEST);

// update-payment
const updatePayment = () => genericUserEvent(userActionTypes.SET_PAYMENT_REQUEST);

// update-password
const updatePassword = () => genericUserEvent(userActionTypes.PASSWORD_CHANGE_REQUEST);

// EVENT-MAPPINGS ##########################################################

// user events mappings
export const userEventsMap = {
	[userActionTypes.PASSWORD_TOKEN_REQUEST]    : forgotPassword,
	[userActionTypes.CREATE_USER_SUCCESS]       : signUp,
	[userActionTypes.CANCEL_ACCOUNT_REQUEST]    : cancelAccount,
	[userActionTypes.SET_PAYMENT_REQUEST]       : updatePayment,
	[userActionTypes.PASSWORD_CHANGE_REQUEST]   : updatePassword,
};